import Vue from "vue";

// axios
import axios from "axios";

const axiosIns = axios.create({
    // You can add your headers here
    // ================================
    baseURL: process.env.APP_URL,
    withCredentials: true,
    // timeout: 1000,
    // headers: {'X-Custom-Header': 'foobar'}
    headers: {
        "Content-Type": "application/json"
    }
});

Vue.prototype.$http = axiosIns;

export default axiosIns;
